// extracted by mini-css-extract-plugin
module.exports = {"_searchInput":"BezeichnungEntry__searchInput__YKE8S","_subInfo":"BezeichnungEntry__subInfo__2KW7P"};